import { render, staticRenderFns } from "./RegistrationErrorSummary.vue?vue&type=template&id=258973fc&"
import script from "./RegistrationErrorSummary.vue?vue&type=script&lang=ts&"
export * from "./RegistrationErrorSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports